import { SortDirection } from "@redotech/cockroachdb-codegen/congodb/sort-direction";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const inventorySkuAggregateSortKeySchema = z.enum([
  "title",
  "sku",
  "totalQuantity",
  "totalAvailable",
  "totalBuildable",
  "totalCommitted",
  "totalReserved",
  "inventoryValueCents",
  "priceCents",
]);
export type InventorySkuAggregateSortKey = z.infer<
  typeof inventorySkuAggregateSortKeySchema
>;

const sortDirectionSchema = z.nativeEnum(SortDirection);
export type InventorySkuAggregateSortDirection = SortDirection;
export { SortDirection };

export const inventorySkuGradeQuantitySchema = z.object({
  grade: z.string().nullable(),
  quantity: z.number(),
});
export type InventorySkuGradeQuantity = z.infer<
  typeof inventorySkuGradeQuantitySchema
>;

const inventorySkuAggregateSchema_ = z.object({
  productId: z.string(),
  title: z.string(),
  sku: z.string().nullable(),
  upc: z.string().nullable(),
  sourceId: z.string().nullable(),
  imageUrl: z.string().nullable(),
  priceCents: z.number().nullable(),
  currency: z.string().nullable(),
  inventoryValueCents: z.number().nullable(),
  totalQuantity: z.number(),
  totalAvailable: z.number(),
  totalBuildable: z.number(),
  totalCommitted: z.number(),
  totalReserved: z.number(),
  gradeBreakdown: z.array(inventorySkuGradeQuantitySchema),
  locationNames: z.array(z.string()),
  lastInventoryUpdatedAt: z.date().nullable(),
});
export const inventorySkuAggregateSchema: z.ZodType<InventorySkuAggregate> =
  inventorySkuAggregateSchema_;
export interface InventorySkuAggregate extends z.infer<
  typeof inventorySkuAggregateSchema_
> {}

export const getInventorySkuAggregates = unaryRpc({
  name: "getInventorySkuAggregates" as const,
  input: z.object({
    returnsCenterId: z.string().optional(),
    page: z.number().min(0).optional(),
    pageSize: z.number().min(1).max(500).default(50),
    search: z.string().optional(),
    sortBy: inventorySkuAggregateSortKeySchema.optional(),
    sortDirection: sortDirectionSchema.optional(),
  }),
  output: z.object({
    items: z.array(inventorySkuAggregateSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});

export type InventorySkuAggregatesOutput = z.infer<
  (typeof getInventorySkuAggregates)["output"]
>;
